import React from "react";
import axios from "../../util/axiosConfig";

export default function MaintenanceBanner({ style, className }) {
  const [banner, setBanner] = React.useState(null);
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;

    axios.get("/api/auth/get-banner-details")
      .then(({ data }) => {
        const bannerDetails = Array.isArray(data) ? data[0] : data;

        if (mounted && bannerDetails) {
          setBanner(bannerDetails);
          setVisible(bannerDetails.bannerStatus === true);
        }
      })
      .catch(() => {
        if (mounted) {
          setVisible(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (!visible || !banner) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Maintenance notice"
      className={className}
      title={banner.bannerContent}
      style={style}
    >
      <span>{banner.bannerContent}</span>

      <button
        onClick={() => setVisible(false)}
        aria-label="Close maintenance notice"
        type="button"
      >
        &times;
      </button>
    </div>
  );
}
